import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiVisualstudiocode,
  SiPostman,
  // SiSlack,
  SiVercel,
  // SiMacos,
  SiJupyter,
  SiWindows,
  SiGooglecolab,
  SiStreamlit,
  SiGithub,
  SiGit,
  SiMacos,
  SiLinux,
  SiUbuntu,
  SiJsonwebtokens,
  SiWireshark,
  SiCisco,
  SiMongodb,
  SiVirtualbox,
  SiRender,
} from "react-icons/si";

function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <SiWindows />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiMacos />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiUbuntu />
      </Col>
       <Col xs={4} md={2} className="tech-icons">
        <SiGit />
      </Col>
       <Col xs={4} md={2} className="tech-icons">
        <SiGithub />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiVisualstudiocode />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiPostman />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiJupyter />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiVercel />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiGooglecolab />
      </Col>
       <Col xs={4} md={2} className="tech-icons">
        <SiStreamlit />
      </Col>
       <Col xs={4} md={2} className="tech-icons">
        <SiJsonwebtokens />
      </Col>
       <Col xs={4} md={2} className="tech-icons">
        <SiWireshark />
      </Col>
       <Col xs={4} md={2} className="tech-icons">
        <SiVirtualbox />
      </Col>
       <Col xs={4} md={2} className="tech-icons">
        <SiRender />
      </Col>
    </Row>
  );
}

export default Toolstack;
